export const tooltipStyles = {
  tooltip: {
    sx: {
      bgcolor: '#4D4C53',
      padding: '6px 7px 8px 9px',
      '& .MuiTooltip-arrow': {
        color: '#4D4C53'
      },
      border: '0px solid black'
    }
  }
};
